'use strict';
moduleConfig.registerModule('eclipseApp.user', ['eclipseApp.core', 'ute.fraud.logging']);
